import React from 'react';
import { Link } from 'react-router-dom';
import { getNavIconClass } from '../../../../navigation/clinicNavConfig';
import { getReputationAvatarTheme } from '../subparts/reputationTheme';
import {
    formatReputationDate,
    getCommentStatusMeta,
    getFeedbackMeta,
    getPatientInitials,
} from '../subparts/reputationQuery';

function OverviewTab({ shortCode, reputationLinks, patientComments, patientFeedbacks }) {
    const stats = [
        { label: 'Active links', value: reputationLinks?.length ?? 0 },
        { label: 'Comments', value: patientComments?.totalElements ?? 0 },
        { label: 'Feedback', value: patientFeedbacks?.totalElements ?? 0 },
        { label: 'Short code', value: shortCode?.shortCode || '—' },
    ];

    const latestComments = patientComments?.content?.slice(0, 5) || [];
    const latestFeedbacks = patientFeedbacks?.content?.slice(0, 5) || [];

    return (
        <div className="h-100 d-flex flex-column min-h-0">
            <div className="reputation-toolbar">
                <div>
                    <h2 className="reputation-toolbar__title">Overview</h2>
                    <p className="reputation-toolbar__subtitle mb-0">
                        Snapshot of links, comments, and feedback
                    </p>
                </div>
            </div>

            <div className="reputation-tab-content">
                <div className="reputation-stats">
                    {stats.map((stat) => (
                        <div key={stat.label} className="reputation-stat">
                            <span className="reputation-stat__label">{stat.label}</span>
                            <span className="reputation-stat__value">{stat.value}</span>
                        </div>
                    ))}
                </div>

                <div className="reputation-activity-grid">
                    <section className="reputation-card">
                        <div className="reputation-card__header">
                            <h3 className="reputation-card__title">Latest comments</h3>
                        </div>
                        <div className="reputation-card__body reputation-card__body--flush">
                            {latestComments.length > 0 ? (
                                latestComments.map((comment, index) => {
                                    const statusMeta = getCommentStatusMeta(comment.status);

                                    return (
                                        <div key={comment.id} className="reputation-activity-item">
                                            <span
                                                className={`reputation-avatar ecx-nav-icon ${getNavIconClass(
                                                    getReputationAvatarTheme(comment.patientId, index)
                                                )}`}
                                            >
                                                {getPatientInitials(comment.firstName, comment.lastName)}
                                            </span>
                                            <div className="min-width-0 flex-grow-1">
                                                <div className="reputation-activity-item__top">
                                                    <h4 className="reputation-activity-item__title">
                                                        {comment.patientId ? (
                                                            <Link
                                                                to={`/patient-files/${comment.patientId}`}
                                                                className="reputation-patient-link"
                                                            >
                                                                {comment.firstName} {comment.lastName}
                                                            </Link>
                                                        ) : (
                                                            <>
                                                                {comment.firstName} {comment.lastName}
                                                            </>
                                                        )}
                                                    </h4>
                                                    <span className={statusMeta.className}>{statusMeta.label}</span>
                                                </div>
                                                <p className="reputation-activity-item__text mb-0">
                                                    {comment.notes || '—'}
                                                </p>
                                                <span className="reputation-activity-item__date">
                                                    {formatReputationDate(comment.createdAt)}
                                                </span>
                                            </div>
                                        </div>
                                    );
                                })
                            ) : (
                                <div className="reputation-activity-empty">No comments yet</div>
                            )}
                        </div>
                    </section>

                    <section className="reputation-card">
                        <div className="reputation-card__header">
                            <h3 className="reputation-card__title">Recent feedback</h3>
                        </div>
                        <div className="reputation-card__body reputation-card__body--flush">
                            {latestFeedbacks.length > 0 ? (
                                latestFeedbacks.map((feedback, index) => {
                                    const feedbackMeta = getFeedbackMeta(feedback.feedback);

                                    return (
                                        <div key={feedback.id} className="reputation-activity-item">
                                            <span
                                                className={`reputation-avatar ecx-nav-icon ${getNavIconClass(
                                                    getReputationAvatarTheme(feedback.id, index)
                                                )}`}
                                            >
                                                {feedback.patientName?.charAt(0) || '?'}
                                            </span>
                                            <div className="min-width-0 flex-grow-1">
                                                <div className="reputation-activity-item__top">
                                                    <h4 className="reputation-activity-item__title">
                                                        {feedback.patientId ? (
                                                            <Link
                                                                to={`/patient-files/${feedback.patientId}`}
                                                                className="reputation-patient-link"
                                                            >
                                                                {feedback.patientName}
                                                            </Link>
                                                        ) : (
                                                            feedback.patientName
                                                        )}
                                                    </h4>
                                                    <span className={feedbackMeta.className}>
                                                        <i className={`bi ${feedbackMeta.icon}`} aria-hidden="true"></i>
                                                        {feedbackMeta.label}
                                                    </span>
                                                </div>
                                                <span className="reputation-activity-item__date">
                                                    {formatReputationDate(feedback.createdAt)}
                                                </span>
                                            </div>
                                        </div>
                                    );
                                })
                            ) : (
                                <div className="reputation-activity-empty">No feedback yet</div>
                            )}
                        </div>
                    </section>
                </div>
            </div>
        </div>
    );
}

export default OverviewTab;
